import { Alert } from 'avo-ui'
import { BannerSection } from 'components/award/nomination/banner-section/BannerSection'
import { useValidation } from 'hooks/useValidation'
import { useEffect, useState } from 'react'
import { API_AWARD } from 'services/apiAward'
import { METHOD } from 'services/method'
import { useFetch } from 'services/useFetch'
import { uploadFileToS3 } from 'utils/utils'

const INITIAL_STATE = {
    is_show: false,
    desktop_banner: null,
    mobile_banner: null,
}

const VALIDATION = {
    desktop_banner: {
        required: 'Banner desktop wajib diisi',
    },
    mobile_banner: {
        required: 'Banner mobile wajib diisi',
    },
}

export const BannerSectionContainer = () => {
    const [form, setForm] = useState(INITIAL_STATE)
    const [isLoadingUpload, setLoadingUpload] = useState(false)
    const { fetching: getBanner, isLoading } = useFetch(API_AWARD.NOMINATION_BANNER)
    const { fetching: updateBanner, isLoading: isUpdating } = useFetch({
        ...API_AWARD.NOMINATION_BANNER,
        method: METHOD.PUT,
    })
    const { fetching: getURLImage } = useFetch(API_AWARD.URL_AWARD_IMAGE)
    const { errorForm, validateForm } = useValidation({ form: form, schema: VALIDATION })

    useEffect(() => {
        fetchBanner()
    }, [])

    const fetchBanner = async () => {
        const response = await getBanner()
        setForm(response?.data)
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setForm({ ...form, [name]: value })
    }

    const handleUploadImage = async (files) => {
        let newFormImage = {}
        const fileNames = Object.entries(files).map(([key, item]) => item.name)

        const s3Urls = await getURLImage({ files: fileNames })
        const newEntries = Object.entries(files).map(([key, item], index) => {
            return [key, { ...item, ...s3Urls?.data?.[index] }]
        })

        const s3UrlsWithKey = Object.fromEntries(newEntries)
        await Promise.all(
            Object.entries(s3UrlsWithKey).map(async ([key, item], index) => {
                await uploadFileToS3(item, item.file)
                newFormImage = {
                    ...newFormImage,
                    [key]: `${s3UrlsWithKey?.[key]?.url}${s3UrlsWithKey?.[key]?.fields?.key}`,
                }
            }),
        )
        return newFormImage
    }

    const onSubmit = async () => {
        await validateForm()
        let files = {}
        if (form?.desktop_banner?.file) files = { ...files, desktop_banner: form?.desktop_banner }
        if (form?.mobile_banner?.file) files = { ...files, mobile_banner: form?.mobile_banner }

        let payload = { ...form }

        if (Object.entries(files).length > 0) {
            setLoadingUpload(true)
            payload = {
                ...payload,
                ...(await handleUploadImage(files)),
            }
            setLoadingUpload(false)
        }
        await updateBanner(payload)
        await fetchBanner()
        Alert({
            icon: 'success',
            title: 'Success',
            message: 'Banner Section Updated!',
        })
    }

    const props = {
        data: form,
        onChangeForm,
        errorForm,
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }
    return <BannerSection {...props} />
}
